import { RegisterChaeckInfoResponse } from 'api/evisaAPI/auth'
import { FailResponse } from 'api/evisaAPI/dlAPI'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  random?: number
  errorMessage?: string
} & Status

const initialState: State = {
  isLoading: false,
  success: false,
  fail: false,
  random: undefined,
  errorMessage: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.REGISTER_CHECK_INFO_ASYNC,
    Actions.REGISTER_CHECK_INFO_SUCCESS,
    Actions.REGISTER_CHECK_INFO_FAIL,
    RegisterChaeckInfoResponse,
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.REGISTER_CHECK_INFO_SUCCESS:
      return {
        ...state,
        ...action.status,
        random: action.payload.random,
      }
    case Actions.REGISTER_CHECK_INFO_ASYNC:
      return {
        ...state,
        ...action.status,
      }
    case Actions.REGISTER_CHECK_INFO_FAIL:
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error.message || '',
      }
    default:
      return state
  }
}
